// extracted by mini-css-extract-plugin
export var collapsedSummary = "_nd-0";